import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  max-width: calc(100% - 42px);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-grow: 1;\n  text-decoration: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  margin: 0;\n  color: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 10px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  height: 22px;\n  width: 22px;\n  border: 1px solid ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled from '../utils/styling/styled-components';
var ChecklistItemContainer = styled.div(_templateObject());
var ChecklistItemEmptyCheck = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.stoneLight;
});
var ChecklistItemCheckContainer = styled(ChecklistItemEmptyCheck)(_templateObject3(), function (props) {
  return props.theme.colors.green;
});
var ChecklistItemText = styled.p(_templateObject4(), function (props) {
  return props.theme.colors.slate;
});
var StyledItemLink = styled.a(_templateObject5());

var ChecklistItem = function ChecklistItem(_ref) {
  var label = _ref.label,
      completed = _ref.completed,
      url = _ref.url,
      alert = _ref.alert,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(ChecklistItemContainer, {
    className: className
  }, completed ? /*#__PURE__*/React.createElement(ChecklistItemCheckContainer, null, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.ThickCheckmark,
    width: "12px",
    height: "12px"
  })) : /*#__PURE__*/React.createElement(ChecklistItemEmptyCheck, null), /*#__PURE__*/React.createElement(StyledItemLink, {
    href: url
  }, /*#__PURE__*/React.createElement(ChecklistItemText, null, label), alert && /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.WarningYellow,
    width: "20px",
    style: {
      marginRight: '14px'
    }
  })), /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.ChevronRight,
    height: "10px",
    width: "10px"
  }));
};

export { ChecklistItem };